import { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1 } from "../../../../../../config/constants";
// Components
import { MainDiv, Header, Title, Span, OpenButton, OpenButtonImg } from "./styles";
import Graphic from "../../../graphic";
import NoDataComponent from "../../../noDataComponent";
// Assets
import ArrowUpImg from "../../../../../../assets/icons/ico_arrow_up_blue.svg";
import ArrowDownImg from "../../../../../../assets/icons/ico_arrow_down_blue.svg";

const DiagnosticAssessmentsPlot = ({ sessions, protocolFunction, protocolTitle }) => {
  const [showPlot, setShowPlot] = useState(false);
  const [successRatesArray, setSuccessRatesArray] = useState([]);

  useEffect(() => {
    const successRates = sessions.map((session) => {
      if (!session?.totalErrors || !session?.totalSuccess) return NaN;
      const total = session.totalErrors + session.totalSuccess;
      return parseInt((session.totalSuccess / total) * 100);
    });
    setSuccessRatesArray(successRates);
    return () => {
      setSuccessRatesArray([]);
    };
  }, [sessions]);

  const sessionsData = {
    labels: sessions.map((_, i) => i + 1),
    datasets: [
      {
        label: "Success rate",
        data: successRatesArray,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
    ],
  };

  const options = {
    clip: false,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        labels: {
          usePointStyle: true,
          filter: (legendItem, chartData) => {
            let entries = chartData.datasets.map((e) => e.label);
            return entries.indexOf(legendItem.text) === legendItem.datasetIndex;
          },
        },
      },
      tooltip: {
        displayColors: false,
        callbacks: {
          title: (tooltipItems) => {
            const index = tooltipItems[0].dataIndex;
            return `Diagnostic session ${index + 1}`;
          },
          label: (tooltipItem) => {
            const session = sessions[tooltipItem.dataIndex];
            const totalSuccess = session?.totalSuccess ? session.totalSuccess : 0;
            const totalErrors = session?.totalErrors ? session.totalErrors : 0;
            const total = totalErrors + totalSuccess;
            const rate = total === 0 ? 0 : parseInt((totalSuccess / total) * 100);
            return [`Success rate → ${rate}%`, `Hits → ${session.totalSuccess}`, `Errors → ${session.totalErrors}`];
          },
        },
      },
    },
  };

  return (
    <MainDiv>
      <Header>
        <Title>
          <Span>{protocolFunction}</Span> {protocolTitle}
        </Title>
        <OpenButton onClick={() => setShowPlot(!showPlot)}>
          <OpenButtonImg src={showPlot ? ArrowUpImg : ArrowDownImg} alt="arrow-ico" />
        </OpenButton>
      </Header>
      {showPlot &&
        (Boolean(sessions.length) ? (
          <Graphic
            Title={""}
            Type={Line}
            data={sessionsData}
            options={options}
            axisY={"Success rate (%)"}
            axisX={"Diagnostic sessions"}
            max={100}
          />
        ) : (
          <NoDataComponent text="There are no sessions done" />
        ))}
    </MainDiv>
  );
};

export default DiagnosticAssessmentsPlot;
